<template>
  <div class="firstAccess-container">

    <div v-if="$forSize['desktop-up']" class="access-eBooks">
      <span v-html='$config.strings["home-firstAccessCard-1"]' />
      <t-button :size="'lg'" :backgroundColor="$config.colors.primary" :color="$config.colors.on.primary" @click="loginRedirect" v-html="$config.strings['home-firstAccessCard-btn']"/>
    </div>

    <div v-if="$config.featureFlags['EXIBIR_PRIMEIROACESSO']" class="login-card" >

      <div class="firstAccess-helper-header">
        <div class="acessar-curso-title" v-html="$config.strings['home-firstAccessCard-2']"/>
        <span v-html="$config.strings['home-firstAccessCard-3']"/>
      </div>

      <div class="firstAccess-helper-content">
        <div class="firstAccess-helper-block" v-if="$config.featureFlags['EXIBIR_PRIMEIROACESSO_TEXTO_01']">
          <div v-if="$config.featureFlags['EXIBIR_PRIMEIROACESSO_ICONE']"><img :src="$config.images['iconQuestion']" /></div>
          <div>
            <span v-html="$config.strings['home-firstAccessCard-4']" />
            <span v-html="$config.strings['home-firstAccessCard-5']" />
            <a class="firstAccess-helper-anchor" @click="() => $events.$emit('OPEN-ACCESS-CODE-MODAL')" v-html="$config.strings['home-firstAccessCard-7']" />
          </div>
        </div>

        <div class="firstAccess-helper-block" v-if="$config.featureFlags['EXIBIR_PRIMEIROACESSO_TEXTO_02']">
          <div v-if="$config.featureFlags['EXIBIR_PRIMEIROACESSO_ICONE']"><img :src="$config.images['iconQuestion']" /></div>
          <div>
            <span v-html="$config.strings['home-firstAccessCard-4']" />
            <span v-html="$config.strings['home-firstAccessCard-6']" />
            <a class="firstAccess-helper-anchor" @click="() => $events.$emit('OPEN-FIRST-ACCESS-DIALOG')" v-html="$config.strings['home-firstAccessCard-7']" />
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { TButton } from '@/components/base'

export default {
  name: 'login-card',
  components: { TButton },
  methods: {
    loginRedirect () {
      location.href = this.$config.urls.login_url
    }
  }
}
</script>

<style lang="scss" scoped>
  .firstAccess-container {
    width: 100%;
    font-size: 16px;

    @include for-size(desktop-up) {
      max-width: 250px;
    }

    .access-eBooks {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-end;
      padding-bottom: 30px;
      width: 100%;

      > span {
        padding-right: 10px;
      }

      > button {
        padding: 5px 35px;
        font-size: 20px;
        text-transform: initial;
        font-weight: 500;
        letter-spacing: 0.41px;
      }
    }

    .login-card {
      background-color: var(--secondary-dark);
      color: var(--on-secondary-dark);
      border-radius: 14px;
      box-shadow: 4px 5px 10px 0 rgba(0, 0, 0, 0.16);
      overflow: hidden;
      width: 100%;

      & > * {
        width: 100%;
      }

      .firstAccess-helper-header {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 16px 14px 12px 14px;

        .acessar-curso-title {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          text-transform: uppercase;
          font-weight: bolder;
        }

        button {
          margin: 22px 0;
        }
      }

      .firstAccess-helper-content {
        background-color: var(--secondary-light);
        color: var(--on-secondary-light);
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        padding: 0 8px 16px;

        .firstAccess-helper-block {
          display: flex;
          flex-flow: row nowrap;
          justify-items: center;
          align-content: center;

          &:first-child {
            padding-bottom: 16px;
            padding-top: 16px;
          }

          & > div {
            display: flex;
            flex-flow: column nowrap;

            &:first-child {
              padding-right: 6px;

              > img {
                height: 16px;
                width: 16px;
              }
            }

            .firstAccess-helper-anchor {
              text-decoration: underline;
              cursor: pointer;
              color: var(--on-secondary-light);
              font-size: 14px;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
</style>
